import { IRecord, IRecordType } from 'annotation-tools/utils';

// immutable object generator
export const ICompany = IRecord<CompanyType>({
  id: 0,
  koumutenId: 0,
  name: '',
  dateCreated: 0,
  dateUpdated: 0,
  numProjects: 0,
  numModels: 0,
  canBeDeleted: false
});

// immutable type
export type ICompanyType = IRecordType<CompanyType>;

type CompanyType = {
  id: number;
  koumutenId: number;
  name: string; // 設計会社名 [1..50] characters
  dateCreated: number;
  dateUpdated: number;
  numProjects: number; // プロジェクト数
  numModels: number; // 推論モデル数
  canBeDeleted: boolean;
};
